import { useEffect, useState } from 'react';


export function useDebouncedSearch(value: string) {
  const normalized = value.trim();
  const [settled, setSettled] = useState(normalized);
  useEffect(() => {
    const timer = setTimeout(() => setSettled(normalized), 300);
    return () => clearTimeout(timer);
  }, [normalized]);
  return normalized === settled ? settled : '';
}
